package com.essntl.features.itinerary.ui.edit_itinerary

enum class MessageSendType {
    SUPPLIER_PO, SUPPLIER_GENERIC, CLIENT, TRAVEL_AGENT;

    val isSupplierMessage: Boolean
        get() = this == SUPPLIER_PO || this == SUPPLIER_GENERIC
}